let _primaryTracker = null;
export const getPrimaryTracker = () => {
  if (!_primaryTracker) {
    throw new Error('usage-tracker-container error. "getPrimaryTracker" was be called before "setPrimaryTracker".');
  }

  return _primaryTracker;
};
export const setPrimaryTracker = tracker => {
  if (_primaryTracker) {
    throw new Error('usage-tracker-container error. Primary tracker has already been set. You can only set one primary tracker per runtime.');
  }

  _primaryTracker = tracker;
};